export function stripTags(str) {
  return str.replace(/(<([^>]+)>)/g, '');
}

export function escapeAttr(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
